import React from 'react';

export const Content = (props) => (
  <main>
  	{props.children}
  </main>
)
